import { createSlice } from '@reduxjs/toolkit';
import { downloadPreStockListing, getPreStockListing } from '../../apis';

export const sharedVendorInventory = createSlice({

    name: 'sharedVendorInventory',
    initialState: {
        loading: false,
        error: '',
        data: [],
        updateSuccess: false,
        downloadSuccess: false
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPreStockListing.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getPreStockListing.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data
        })
        builder.addCase(getPreStockListing.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downloadPreStockListing.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(downloadPreStockListing.fulfilled, (state, action) => {
            state.loading = false;
            // state.data = action.payload.data
            state.downloadSuccess = true
        })
        builder.addCase(downloadPreStockListing.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
    }
})

export const { clearError, clear } = sharedVendorInventory.actions

export default sharedVendorInventory.reducer